module.exports = __webpack_public_path__ + "img/emoji_24.9b77b09f.png";